import { render, staticRenderFns } from "./ArticleForm.vue?vue&type=template&id=8c4b4f26"
import script from "./ArticleForm.vue?vue&type=script&lang=ts"
export * from "./ArticleForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports